<div class="main-view space-y-4">
    <app-page-surface-header
        titleIcon="lock"
        title="Manage Permissions"
        [subtitle]="role ? 'Roles and permissions — ' + role.role_name : 'Roles and permissions'"
    />

    <div *ngIf="loading()" class="flex min-h-[300px] items-center justify-center">
        <span class="inline-block h-10 w-10 animate-spin rounded-full border-2 border-gray-300 border-t-primary"></span>
    </div>
    <ng-container *ngIf="!loading()">
        <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
            <div class="flex items-center gap-2">
                <label
                    class="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg border border-gray-200 dark:border-[#191e3a] bg-white dark:bg-[#0e1726] px-3 py-1.5 text-sm font-medium select-none"
                    [class.cursor-pointer]="roleAttachSlugs | hasPermission"
                    [class.opacity-60]="!(roleAttachSlugs | hasPermission)">
                    <input type="checkbox" [checked]="selectAllGlobal"
                        [disabled]="!(roleAttachSlugs | hasPermission)"
                        (change)="onGlobalSelectAll($any($event.target).checked)"
                        class="size-4 shrink-0 rounded border-gray-300 text-success" />
                    <span class="whitespace-nowrap">Select All</span>
                </label>
                <select [(ngModel)]="filterModule"
                    class="form-select rounded-lg border-gray-200 dark:border-[#191e3a] py-1.5 px-3 text-sm bg-white dark:bg-[#0e1726] dark:text-white-dark">
                    <option value="">All Permissions</option>
                    <option *ngFor="let mod of moduleOptions" [value]="mod">{{ mod }}</option>
                </select>
            </div>
            <div class="flex items-center gap-2">
                <span class="text-xs text-gray-400">{{ selectedCount }}/{{ totalCount }} selected</span>
                <button type="button" (click)="onBack()"
                    class="rounded-lg border border-gray-200 dark:border-[#191e3a] px-4 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-white/5">
                    Back
                </button>
                @if ((P.ROLE_UPDATE_PERMISSIONS | hasPermission) || (roleAttachSlugs | hasPermission)) {
                <button
                    type="button"
                    (click)="onSave()"
                    [disabled]="saving()"
                    class="btn rounded-full bg-[#303030] px-8 font-semibold text-white shadow-lg disabled:cursor-not-allowed disabled:opacity-60"
                >
                    {{ saving() ? 'Saving…' : 'Save Permissions' }}
                </button>
                }
            </div>
        </div>

        <div *ngIf="filteredGroups.length === 0"
            class="rounded-xl bg-white dark:bg-dark border border-gray-100 dark:border-[#191e3a] p-12 text-center text-gray-400">
            No permissions available.
        </div>

        <div class="space-y-4">
            <div *ngFor="let group of filteredGroups"
                class="rounded-xl bg-white dark:bg-dark border border-gray-100 dark:border-[#191e3a] overflow-hidden">
                <div
                    class="flex items-center justify-between border-b border-gray-100 dark:border-[#191e3a] bg-gray-50 dark:bg-[#0e1726] px-5 py-3">
                    <h3 class="text-sm font-semibold text-gray-800 dark:text-white">{{ group.module }}</h3>
                    <label
                        class="inline-flex items-center gap-1.5 text-xs font-medium text-gray-500 select-none"
                        [class.cursor-pointer]="roleAttachSlugs | hasPermission"
                        [class.opacity-60]="!(roleAttachSlugs | hasPermission)">
                        Select All
                        <input type="checkbox" [checked]="group.selectAll"
                            [disabled]="!(roleAttachSlugs | hasPermission)"
                            (change)="onGroupSelectAll(group, $any($event.target).checked)"
                            class="rounded border-gray-300 text-success" />
                    </label>
                </div>
                <div class="p-4">
                    <div class="grid grid-cols-2 gap-x-8 gap-y-3 sm:grid-cols-3 lg:grid-cols-4">
                        <label *ngFor="let perm of group.permissions"
                            class="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 select-none"
                            [class.cursor-pointer]="roleAttachSlugs | hasPermission"
                            [class.opacity-60]="!(roleAttachSlugs | hasPermission)">
                            <input type="checkbox" [(ngModel)]="perm.selected" (change)="onPermissionChange(group)"
                                [disabled]="!(roleAttachSlugs | hasPermission)"
                                class="rounded border-gray-300 text-success" />
                            {{ perm.name }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <app-audit-history *ngIf="roleId" resourceType="role" [resourceId]="roleId" class="mt-5 block"></app-audit-history>
    </ng-container>
</div>